import { gql } from '@apollo/client';

/**
 * Query to get a user's login by their email address
 * Uses the exact same query structure as PartySearch component
 */
export const GetUserByEmailQuery = gql`
  query GetUserByEmail($filter: UserListFilter!) {
    identity {
      users(filter: $filter) {
        login
        firstName
        lastName
        displayName
        email
      }
    }
  }
`;
